import { ModuleWithProviders } from "@angular/core";
import { RouterModule } from "@angular/router";

import { AuthGuard } from "@core/guards/auth.guard";
import { CartaoComponent } from "./pages/cartao/cartao.component";
import { RootComponent } from "./root/root.component";


export const routing: ModuleWithProviders = RouterModule.forChild([
  {
    path: "cartao",
    component: RootComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: CartaoComponent,

      },
      { path: "home", component: CartaoComponent },
    ]
  }
]);
